import { pvpBrawl } from './brawl';
import { pvpMisc } from './misc';
import { pvpWeekly } from './weekly';

export const pvpTasks = [pvpBrawl, pvpWeekly, pvpMisc];
